
import { ModuleManagerService } from '../services/module-manager.service';

export class ExtendService {

	parent: any;
	parts: string[];
	callBack: Function;

	constructor(namespace: ModuleManagerService, namespaceExtension: string, fn: Function) {

		this.parent = namespace;
		this.parts = namespaceExtension.split('.');
		this.callBack = fn;

		this.init();

	}

	init() : any {

		if (this.parts[0] === 'KILLIMANJARO') {
			this.parts = this.parts.slice(1);
		}

		this.parts.forEach( (item, index, arr) => {

			if (typeof this.parent[item] === 'undefined') {

				this.parent[item] = {};

				if (index === arr.length - 1) {
					this.parent[item] = this.callBack || {};
				}

			}

			this.parent = this.parent[item];

		});

		return this.parent;

	}

}



// WEBPACK FOOTER //
// ./services/extend.service.ts